/**
 * Garante aliases snake_case e camelCase nas avaliações de cada correção (resposta da API Laravel).
 */
export function normalizeCorrecaoAvaliacoesAliases(correcao) {
  if (!correcao || typeof correcao !== 'object') {
    return;
  }

  if (correcao.avaliacoesRedacao && !correcao.avaliacoes_redacao) {
    correcao.avaliacoes_redacao = correcao.avaliacoesRedacao;
  } else if (correcao.avaliacoes_redacao && !correcao.avaliacoesRedacao) {
    correcao.avaliacoesRedacao = correcao.avaliacoes_redacao;
  }
}

/**
 * @param {object|null|undefined} documento
 */
export function normalizeDocumentoCorrecoesAvaliacoes(documento) {
  if (!documento || !Array.isArray(documento.correcoes)) {
    return;
  }

  documento.correcoes.forEach((correcao) => normalizeCorrecaoAvaliacoesAliases(correcao));
}

/**
 * Copia notas da correção (avaliacoes_redacao + subcritérios) para documento.competencias na UI.
 * @returns {boolean} true se ao menos uma nota foi aplicada
 */
export function hydrateCompetenciasNotasFromCorrecao(documento, correcao) {
  if (!documento || !correcao || !Array.isArray(documento.competencias) || documento.competencias.length === 0) {
    return false;
  }

  normalizeCorrecaoAvaliacoesAliases(correcao);

  const avaliacoes = correcao.avaliacoes_redacao || correcao.avaliacoesRedacao;
  if (!Array.isArray(avaliacoes) || avaliacoes.length === 0) {
    return false;
  }

  let applied = false;
  const sameId = (a, b) => a != null && b != null && String(a) === String(b);

  avaliacoes.forEach((avaliacao) => {
    if (!avaliacao?.competencia_id) {
      return;
    }

    const competencia = documento.competencias.find((c) => sameId(c?.id, avaliacao.competencia_id));
    if (!competencia) {
      return;
    }

    const notaPai = Number(avaliacao.nota);
    if (Number.isFinite(notaPai)) {
      competencia.nota = notaPai;
      applied = true;
    }

    const subsAvaliacao = avaliacao.subcriterios;
    if (!Array.isArray(subsAvaliacao) || !Array.isArray(competencia.subcriterios)) {
      return;
    }

    subsAvaliacao.forEach((subAv) => {
      const subId = subAv?.subcriterio_id;
      if (!subId) {
        return;
      }
      const notaSub = Number(subAv?.nota);
      if (!Number.isFinite(notaSub)) {
        return;
      }
      const scLocal = competencia.subcriterios.find((sc) => sameId(sc?.id, subId));
      if (scLocal) {
        scLocal.nota = notaSub;
        applied = true;
      }
    });
  });

  return applied;
}
